import Vue from 'vue';
import Router from 'vue-router';
import Main from './components/Main.vue';
import Hotels from './components/Hotels.vue';
import Hotel from './components/Hotel.vue';

// const qs = require('qs');

Vue.use(Router);

const routes = [
  { path: '/', component: Main },
  { path: '/hotels', component: Hotels },
  { path: '/hotels/:id', component: Hotel },
  { path: '*', component: Main }
];

export default new Router({
  routes
});
